import { graphql } from "babel-plugin-relay/macro";

export const QUERY = graphql`
	query frequentlyAskedQuestionScreen_Query {
		FrequentlyAskedQuestion {
			AllFrequentlyAskedQuestions {
				id
				answer
				question
				sortIndex
			}
		}
	}
`;
